import { useSettingsStore } from '@bv/stores/settings';
import { type ComputedRef, computed } from 'vue';

import AccountSwitcher from '@/components/Main/topbar/AccountSwitcher.vue';

import type { MetaHeader } from '@bv/router';

export const generateHeader = (title: string): ComputedRef<MetaHeader> =>
  computed(() => (useSettingsStore().layoutType === 'new' ? { title } : { component: AccountSwitcher }));
